import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { gql } from "@apollo/client";
import { createPageInfo } from "./helper";
import { PALETTE_SCHEMAS } from "@/lib/constants";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type PaletteObject {\n    id: Int\n    type: String\n    meta: Meta\n    advertising: Advert\n  }\n\n  type Palette {\n    palette_id: ID!\n    name: String\n    id_key: String\n    header: String\n    description: String\n    schema_id: Int\n    schema: String\n    values: JSONObject\n  }\n\n  type PaletteObjectConnection {\n    data: [PaletteObject]\n    pageInfo: PageInfo\n  }\n\n  type Query {\n    palette(id: Int): Palette\n    paletteObjects(id: Int, offset: Int, limit: Int): PaletteObjectConnection\n  }\n"])));
export var resolvers = {
  Query: {
    palette: function () {
      var _palette = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, _ref, _ref2) {
        var id, dataSources, _e$extensions, _e$extensions2, _e$extensions2$respon;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = _ref.id;
                dataSources = _ref2.dataSources;
                _context.prev = 2;
                _context.next = 5;
                return dataSources.palette.getPalette(id);

              case 5:
                return _context.abrupt("return", _context.sent);

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](2);

                if (_context.t0 !== null && _context.t0 !== void 0 && (_e$extensions = _context.t0.extensions) !== null && _e$extensions !== void 0 && _e$extensions.response && (_context.t0 === null || _context.t0 === void 0 ? void 0 : (_e$extensions2 = _context.t0.extensions) === null || _e$extensions2 === void 0 ? void 0 : (_e$extensions2$respon = _e$extensions2.response) === null || _e$extensions2$respon === void 0 ? void 0 : _e$extensions2$respon.status) !== 404) {
                  console.log(_context.t0.extensions.response);
                }

                return _context.abrupt("return", null);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 8]]);
      }));

      function palette(_x, _x2, _x3) {
        return _palette.apply(this, arguments);
      }

      return palette;
    }(),
    paletteObjects: function () {
      var _paletteObjects = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_parent, _ref3, _ref4) {
        var id, offset, limit, dataSources, result, _e$extensions3, _e$extensions4, _e$extensions4$respon;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                id = _ref3.id, offset = _ref3.offset, limit = _ref3.limit;
                dataSources = _ref4.dataSources;
                _context2.prev = 2;
                _context2.next = 5;
                return dataSources.palette.paletteObjects(id, offset, limit);

              case 5:
                result = _context2.sent;
                return _context2.abrupt("return", {
                  data: result.objects,
                  pageInfo: createPageInfo({
                    limit: limit,
                    offset: offset,
                    count: result.total_count
                  })
                });

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](2);

                if (_context2.t0 !== null && _context2.t0 !== void 0 && (_e$extensions3 = _context2.t0.extensions) !== null && _e$extensions3 !== void 0 && _e$extensions3.response && (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : (_e$extensions4 = _context2.t0.extensions) === null || _e$extensions4 === void 0 ? void 0 : (_e$extensions4$respon = _e$extensions4.response) === null || _e$extensions4$respon === void 0 ? void 0 : _e$extensions4$respon.status) !== 404) {
                  console.log(_context2.t0.extensions.response);
                }

                return _context2.abrupt("return", {
                  data: [],
                  pageInfo: createPageInfo({
                    limit: limit,
                    offset: offset,
                    count: 0
                  })
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 9]]);
      }));

      function paletteObjects(_x4, _x5, _x6) {
        return _paletteObjects.apply(this, arguments);
      }

      return paletteObjects;
    }()
  },
  Palette: {
    schema: function schema(palette) {
      return PALETTE_SCHEMAS[palette.schema_id];
    }
  }
};